// Single-tenant admin: routes live at site root (no /{tenant}/ prefix).
const getBasePath = (): string => "";
export const BASE_PATH = getBasePath();

export const paths = {
  home: BASE_PATH || "/",
  login: `${BASE_PATH || ""}/`.replace("//", "/") || "/",
  signup: `${BASE_PATH}/signup`,
  dashboard: `${BASE_PATH}/dashboard`,
  profile: `${BASE_PATH}/profile`,
  changePassword: `${BASE_PATH}/change-password`,
  users: {
    updateDownloadCount: `${BASE_PATH}/users/update-download-count`,
    updateData: `${BASE_PATH}/users/update-data`,
    registration: `${BASE_PATH}/users/registration`,
    download: `${BASE_PATH}/users/download`,
    export: `${BASE_PATH}/users/export`,
    mergeData: `${BASE_PATH}/users/merge-data`,
  },
  export: {
    elibrary: `${BASE_PATH}/export-elibrary`,
    book: `${BASE_PATH}/export-book`,
    article: `${BASE_PATH}/export-article`,
    magazine: `${BASE_PATH}/export-magazine`,
    agam: `${BASE_PATH}/export-agam`,
    manuscript: `${BASE_PATH}/export-manuscript`,
    audio: `${BASE_PATH}/export-audio`,
  },
  shoppingCart: {
    manageStockIndia: `${BASE_PATH}/shopping-cart/manage-stock-india`,
    manageStockUSA: `${BASE_PATH}/shopping-cart/manage-stock-usa`,
    manageStockSpecialUSA: `${BASE_PATH}/shopping-cart/manage-stock-special-usa`,
    manageStockOther: `${BASE_PATH}/shopping-cart/manage-stock-other`,
    manageAddress: `${BASE_PATH}/shopping-cart/manage-address`,
    orderManagement: `${BASE_PATH}/shopping-cart/order-management`,
    purchaseOrders: `${BASE_PATH}/shopping-cart/purchase-orders`,
    shippingManagement: `${BASE_PATH}/shopping-cart/shipping-management`,
  },
  /** Homepage content (public site). */
  content: {
    banner: `${BASE_PATH}/content/banner`,
    featuredBooks: `${BASE_PATH}/content/featured-books`,
    aboutUs: `${BASE_PATH}/content/about-us`,
    committee: `${BASE_PATH}/content/committee`,
    contact: `${BASE_PATH}/content/contact`,
    donate: `${BASE_PATH}/content/donate`,
    terms: `${BASE_PATH}/content/terms`,
    privacyPolicy: `${BASE_PATH}/content/privacy-policy`,
    homeHero: `${BASE_PATH}/content/home-hero`,
    footer: `${BASE_PATH}/content/footer`,
  },
} as const;
